const BASEURL = "https://gujarat-state-app-association-2025-8eoq.onrender.com"; // Adjust as needed
// const BASEURL = "http://localhost:5000"; // Adjust as needed

export default BASEURL;